import gql from "graphql-tag";

const JobsWithApplicationCountPerJob =gql`
	query {
		jobs {
			id
			createdAt
			closedAt
			statusCode
			position
			location {
				name
			}
			positionType
			company {
				name
			}
			description
			stack
			perks {
				title
				id
			}
			customQualifications
			customResponsibilities
			qualifications {
				title
				id
			}
			responsibilities {
				title
				id
			}
			questions {
				type
				skillset
				mandatory
				difficulty
				question
				category
				answers {
					answerString
					val
				}
			}
		}
		applicationCountByJobPositionAllStatus {
			total
			id
		}
	}
`;

export default JobsWithApplicationCountPerJob;
